/**
 * @fileOverView
 * @description Profile View — accordion sections (ACCOUNT, PLAN, SUPPORT,
 * ORGANIZATION, MEMBERSHIPS), same pattern as the vybit settings view.
 * Org sections follow docs/org-accounts-spec.md §5.
 * @copyright 2015-present Flatirontek LLC
 **/

var AmpersandView = require('ampersand-view');
var ProfileTemplate = require('../../templates/widgets/profiletemplate.html');
var Param = require("../../models/param");
var ParamView = require("./param");
var MeterView = require("./meterview");
var OrgMembersView = require("./orgmembersview");
var InviteView = require("../components/invite");
var SearchView = require("../components/search");
var AmpersandCollection = require('ampersand-collection');
var app = require('ampersand-app');
var dialog = require('../../lib/dialog');

var esc = function(s){ return app.utils.escapeHtml(s); };

var ProfileView = AmpersandView.extend({
    template: ProfileTemplate,

    initialize: function (options) {
        this.model = app.profile;

        this.nameParam = new Param({
            "entity" : "profile",
            "name" : "name",
            "label" : "NAME",
            "inputType" : "text",
            "template" : "TextTemplate",
            "placeholder" : "your public Vybit handle"
        });

        this.orgNameParam = new Param({
            "entity" : "profile",
            "name" : "org_name",
            "label" : "NAME",
            "inputType" : "text",
            "template" : "TextTemplate",
            "placeholder" : "An optional name for your organization (overrides your account name) that your account's managers will see."
        });

        this.organizationSettings = new AmpersandCollection([this.orgNameParam]);

        if(app.orgMembers==undefined) app.orgMembers = new app.OrgMembers();
    },

    subviews: {
        name: {
            hook : 'editname',
            prepareView: function(el) {
                return new ParamView({
                    el: el,
                    parent: this,
                    model: this.nameParam
                });
            }
        },

        meter: {
            hook : 'meter',
            prepareView: function(el) {
                return new MeterView({
                    el: el,
                    parent: this,
                    model: app.meter
                });
            }
        },

        orgInvite: {
            hook : 'org-invite',
            prepareView: function(el) {
                return new InviteView({
                    el: el,
                    parent: this,
                    mode: 'org'
                });
            }
        },

        orgSearch: {
            hook : 'org-search',
            prepareView: function(el) {
                return new SearchView({
                    el: el,
                    parent: this,
                    entity: 'orgMembers',
                    emptyResultsSelector: '[data-hook=org-no-results]',
                    resetScroll: false
                });
            }
        },

        orgMembersList: {
            hook : 'org-members-list',
            prepareView: function(el) {
                return new OrgMembersView({
                    el: el,
                    parent: this
                });
            }
        }
    },

    bindings: {
        "model.name": {
            type: 'text',
            hook: 'name'
        },
        "model.email": {
            type: 'text',
            hook: 'email'
        },
        "model.providerDisplay": {
            type: 'text',
            hook: 'provider'
        },
        "model.version": {
            type: 'text',
            hook: 'version'
        },
        //hide the row entirely for non-admins rather than leave it blank
        "model.admin" : [
            {
                type: 'innerHTML',
                hook: 'admin'
            },
            {
                type: 'toggle',
                hook: 'admin-row'
            }
        ]
    },

    render: function(){
        this.renderWithTemplate(this);
        this.renderOrganization();
        this.loadMemberships();
        return this;
    },

    renderOrganization: function(){
        this.renderCollection(this.organizationSettings, ParamView, 'div.vset-organization');
        this.listenTo(app.orgMembers, 'add remove reset sync', this.renderSeats);
        this.renderSeats();
    },

    renderSeats: function(){
        var seats = app.utils.orgSeats();

        //unfiltered count, so an active filter cannot hide the search box the
        //user is typing in
        var searchRow = this.query('[data-hook=org-search-row]');
        if(searchRow) searchRow.style.display = app.utils.showMemberSearch(seats.used) ? '' : 'none';

        var seatsEl = this.query('[data-hook=org-seats]');
        if(seatsEl){
            seatsEl.innerHTML = seats.cap === Infinity
                ? seats.used + ' of unlimited seats used'
                : seats.used + ' of ' + seats.cap + (seats.cap == 1 ? ' seat used' : ' seats used');
        }

        var upsell = this.query('[data-hook=org-upsell]');
        if(upsell){
            var help = app.utils.externalLinkHtml(app.utils.wwwUrl('/organization'), 'How does this work?');
            upsell.innerHTML = seats.remaining === 0
                ? 'All seats on your plan are in use. '
                    + app.utils.externalLinkHtml(app.utils.wwwUrl('/pricing'), 'See plans') + ' for more. &nbsp; ' + help
                : help;
        }
    },

    //the user has taken over; stop forcing the landing section open
    sectionToggled: function(){
        delete app.landingSection;
    },

    expandSection: function(name){
        var section = this.query('#' + name + '-section');
        var button = this.query('#' + name + '-heading .accordion-button');
        if(!section || !button) return;

        section.classList.add('show');
        button.classList.remove('collapsed');
        button.setAttribute('aria-expanded', 'true');

        var account = this.query('#account-section');
        var accountButton = this.query('#account-heading .accordion-button');
        if(account) account.classList.remove('show');
        if(accountButton){
            accountButton.classList.add('collapsed');
            accountButton.setAttribute('aria-expanded', 'false');
        }
    },

    //orgs this person belongs to; the section stays hidden when there are none
    loadMemberships: function(){
        var self = this;
        var item = this.query('[data-hook=memberships-item]');
        var spacer = this.query('[data-hook=memberships-spacer]');
        if(item) item.style.display = 'none';
        if(spacer) spacer.style.display = 'none';

        global.jQuery.ajax(Object.assign({
            url: app.config.restApiUrl + '/org/memberships',
            method: 'GET',
            success: function(rows){
                var el = self.query('[data-hook=memberships]');
                if(!el || !rows || !rows.length) return;

                var html = '';
                rows.forEach(function(m){
                    var name = esc(m.orgName || m.orgKey);
                    var data = ' data-key="' + esc(m.key) + '" data-orgkey="' + esc(m.orgKey) + '" data-orgname="' + name + '"';
                    //primary action beside the name, destructive one on the right
                    var mid = name + ' &nbsp; ';
                    var right = '';

                    if(m.status == 'invited'){
                        mid += '<button class="btn btn-success btn-sm vparam vorg-accept-btn"' + data + '>JOIN</button>';
                        right = '<button class="btn btn-danger btn-sm vparam vorg-decline-btn"' + data + '>DECLINE</button>';
                    } else {
                        if(app.isManagingOrg(m.orgKey)){
                            mid += '<span class="vdesc">managing</span>';
                        } else if(m.manageable === false){
                            mid += '<span class="vdesc">plan inactive</span>';
                        } else {
                            mid += '<button class="btn btn-info btn-sm vparam vorg-manage-btn"' + data + '>MANAGE</button>';
                        }
                        right = '<button class="btn btn-danger btn-sm vparam vorg-leave-btn"' + data + '>REMOVE</button>';
                    }

                    html += '<div class="vrow vparamrow">' +
                        '<label class="vcol vlabel">' + (m.status == 'invited' ? 'INVITED BY' : '') + '</label>' +
                        '<div class="vcol vmid">' + mid + '</div>' +
                        '<div class="vcol vright">' + right + '</div>' +
                        '</div>';
                });

                el.innerHTML = html;
                if(item) item.style.display = '';
                if(spacer) spacer.style.display = '';

                //re-applied on every render: boot renders the page twice and
                //a one-shot flag is consumed by the render that gets replaced
                if(app.landingSection == 'memberships') self.expandSection('memberships');
            },
            error: function(){
                app.eventLog.add('error loading org memberships', 'error');
            }
        }, app.utils.setPersonalAuthTokenHeader()));
    },

    events: {
        "click .sound-acq" : "switchToSACQPage",
        "click .event-log" : "switchToEventLogPage",
        "click .vyblogout" : "logout",
        "click [data-hook='docs']" : "switchToDocsPage",
        "click button.vbtndelete" : "deleteAccount",
        "click .accordion-button" : "sectionToggled",
        "click .vorg-accept-btn" : "acceptInvite",
        "click .vorg-decline-btn" : "declineInvite",
        "click .vorg-leave-btn" : "leaveOrg",
        "click .vorg-manage-btn" : "manageOrg"
    },

    switchToSACQPage: function(){
        var view =   new app.SoundAcquisitionPageView({viewOptions: {mode:'lib'}});
        app.pageSwitcher.set(view);
    },

    switchToEventLogPage: function(){
        var view =   new app.EventLogPageView();
        app.pageSwitcher.set(view);
    },

    switchToDocsPage: function(){
        var view =   new app.DocsPageView();
        app.pageSwitcher.set(view);
    },

    respondToInvite: function(key, status, done){
        var self = this;
        global.jQuery.ajax(Object.assign({
            url: app.config.restApiUrl + '/org/membership/' + key,
            method: 'PUT',
            contentType: 'application/json',
            data: JSON.stringify({status: status}),
            success: done,
            error: function(xhr){
                var msg = xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : 'error updating invitation';
                dialog.alert(msg);
            }
        }, app.utils.setPersonalAuthTokenHeader()));
    },

    //joining does not switch context; the row becomes MANAGE/REMOVE
    acceptInvite: function(e){
        var self = this;
        this.respondToInvite(e.target.dataset.key, 'active', function(){
            self.loadMemberships();
        });
    },

    //the member's own counterpart to the owner revoking them
    leaveOrg: async function(e){
        var self = this;
        var d = e.target.dataset;
        if(!await dialog.confirm('Stop managing "' + d.orgname + '"? You will lose manager access and your subscriptions to its private vybits.', {title: 'Leave organization', okText: 'Stop managing', danger: true})) return;
        this.respondToInvite(d.key, 'revoked', function(){
            if(app.isManagingOrg(d.orgkey)) app.switchOrgContext(null);
            else self.loadMemberships();
        });
    },

    declineInvite: function(e){
        var self = this;
        this.respondToInvite(e.target.dataset.key, 'declined', function(){
            self.loadMemberships();
        });
    },

    manageOrg: function(e){
        app.switchOrgContext({key: e.target.dataset.orgkey, name: e.target.dataset.orgname});
    },

    logout: function () {
        app.auth.signOut();
    },

    deleteAccount: async function(){
        if(await dialog.confirm('Are you sure you want to permanently delete your Vybit account including all Vybits and Logs?', {title: 'Delete account', okText: 'Delete account', danger: true})){
            app.auth.deleteAccount();
        }
    }

});

module.exports = ProfileView;
